module.exports = __webpack_public_path__ + "resources/img/img_i_onenet_m.52c23d64d58b86108362bde4ffc1cfe4.png";